import { AnyTask, TaskRoute } from "tm-shared/types";

export const sortStartVisitFirstTasks = (tasks: AnyTask[]): AnyTask[] => {
    return [...tasks].sort((a, b) => {
        const aIsStart = a.context.route === TaskRoute.StartVisit;
        const bIsStart = b.context.route === TaskRoute.StartVisit;

        if (aIsStart === bIsStart) return 0;
        return aIsStart ? -1 : 1;
    });
};
